import { render } from "./Lp.vue?vue&type=template&id=8f970e86&scoped=true"
import script from "./Lp.vue?vue&type=script&lang=js"
export * from "./Lp.vue?vue&type=script&lang=js"

import "./Lp.vue?vue&type=style&index=0&id=8f970e86&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f970e86"]])

export default __exports__